export const formatTelLink = (phone) => {
  if (phone == null || typeof phone !== 'string') {
    return '';
  }
  return phone.replace(/[^\d+]/g, '');
};
